/**
 * CSV Template Utilities
 *
 * Helper functions for generating and downloading CSV templates
 */

/**
 * Generate a CSV template file for device associations
 */
export function generateDeviceAssociationsTemplate(): string {
  const headers = ['device_id', 'start_time', 'end_time'];
  const examples = [
    ['DEV-001', '2024-01-01T00:00:00Z', '2024-12-31T23:59:59Z'],
    ['DEV-002', '2024-01-15', ''],
    ['DEV-003', '', ''],
  ];

  const rows = [headers, ...examples];
  return rows.map((row) => row.join(',')).join('\n');
}

/**
 * Download a file with given content
 */
export function downloadFile(content: string, filename: string, mimeType: string = 'text/csv'): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Download device associations CSV template
 */
export function downloadDeviceAssociationsTemplate(): void {
  const content = generateDeviceAssociationsTemplate();
  downloadFile(content, 'device_associations_template.csv');
}
